/**
 * Show/hide toggle (eye icon) for WooCommerce password fields
 * (login, register, checkout create-account, my account, lost password)
 */

const EYE_OPEN =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"/><circle cx="12" cy="12" r="3"/></svg>';

const EYE_CLOSED =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.94 10.94 0 0 1 12 5c7 0 11 7 11 7a13.16 13.16 0 0 1-3.19 3.88M6.61 6.61C3.83 8.34 1 12 1 12s4 7 11 7a10.9 10.9 0 0 0 5.39-1.61"/><path d="M1 1l22 22"/></svg>';

function wrapPasswordField(input) {
  if (input.closest(".woo-password-field")) return;

  const wrapper = document.createElement("span");
  wrapper.className = "woo-password-field";
  input.parentNode.insertBefore(wrapper, input);
  wrapper.appendChild(input);

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "woo-password-toggle";
  toggle.setAttribute("aria-pressed", "false");
  toggle.setAttribute("aria-label", "Tampilkan password");
  toggle.innerHTML = EYE_OPEN;

  toggle.addEventListener("click", () => {
    const isHidden = input.type === "password";
    input.type = isHidden ? "text" : "password";
    toggle.innerHTML = isHidden ? EYE_CLOSED : EYE_OPEN;
    toggle.setAttribute("aria-pressed", String(isHidden));
    toggle.setAttribute("aria-label", isHidden ? "Sembunyikan password" : "Tampilkan password");
  });

  wrapper.appendChild(toggle);
}

export function initPasswordToggle() {
  const inputs = document.querySelectorAll(".woocommerce input[type='password']");
  if (!inputs.length) return;

  inputs.forEach(wrapPasswordField);
}
